export default "__VITE_ASSET__p8$JrqtY__"